var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAspnet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 18,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 27,
    height: 26,
    x: 0,
    y: -8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27-8H0v25.738h27V-8Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M9.317 2.186c.962 2.947 1.334 8.22 4.157 8.22.217 0 .434-.02.652-.062-2.565-.6-2.875-5.811-4.447-8.51-.124.114-.248.227-.362.352Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M9.68 1.833c1.57 2.7 1.87 7.922 4.446 8.511.207-.041.403-.093.61-.165-2.306-1.128-2.947-6.195-4.726-8.635a8.297 8.297 0 0 1-.33.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14559A",
    d: "M11.944.231c-.218 0-.435.02-.652.062-.569.104-1.148.352-1.737.724.155.155.31.341.455.538.6-.497 1.19-.859 1.779-1.076.217-.082.434-.144.661-.186a1.422 1.422 0 0 0-.506-.062Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M16.535 9.145c.248-.196.486-.403.714-.62C16.266 5.578 15.915.23 13.07.23c-.207 0-.414.021-.61.062 2.575.642 2.916 6.277 4.074 8.852Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3092C4",
    d: "M12.45.283a2.06 2.06 0 0 0-.506-.062h1.116c-.206.01-.403.03-.61.062Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1969BC",
    d: "M16.483 9.766c-.113-.104-.217-.228-.32-.352-.476.341-.952.6-1.427.765.165.083.351.145.537.186.145.031.3.042.455.042.528 0 .952-.062 1.314-.238a2.137 2.137 0 0 1-.559-.403Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M11.789.468c2.326 1.21 2.523 6.712 4.374 8.945l.372-.279C15.377 6.569 15.045.924 12.45.282a6.178 6.178 0 0 0-.661.186Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M10.01 1.555c1.779 2.44 2.42 7.507 4.726 8.635a5.664 5.664 0 0 0 1.427-.766C14.312 7.191 14.105 1.69 11.789.48c-.59.218-1.19.58-1.78 1.076Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M8.18 2.113c-.28.63-.57 1.458-.91 2.544.682-.962 1.365-1.8 2.047-2.472a8.385 8.385 0 0 0-.3-.786c-.3.218-.579.455-.837.714Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B74B1",
    d: "m9.255 1.214-.248.186c.103.238.207.507.3.786.124-.114.248-.238.372-.352a3.853 3.853 0 0 0-.424-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#125A9E",
    d: "M9.555 1.017a2.844 2.844 0 0 0-.29.196c.156.186.29.393.424.62.104-.093.218-.186.321-.279a4.783 4.783 0 0 0-.455-.537Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M25.387.004c-1.313 5.067-4.054 9.13-6.36 10.155a.627.627 0 0 1-.124.051c-.01 0-.01 0-.01.01-.01 0-.02.011-.031.011-.01 0-.01 0-.02.01-.022.01-.042.01-.063.021-.01 0-.02.01-.02.01-.011 0-.021.01-.032.01-.01 0-.02.011-.03.011-.011 0-.021 0-.021.01-.021 0-.031.01-.052.01-.01 0-.01 0-.02.011-.011 0-.021.01-.032.01-.01 0-.01 0-.02.01-.01 0-.021.011-.042.011l-.041.01a.897.897 0 0 0 .33.063c2.183 0 4.385-3.91 8.015-10.403L25.387.004Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M6.794.428c.01 0 .01 0 0 0l.01-.01c.01 0 .021-.01.031-.01H6.856c.01 0 .02-.011.041-.011.031-.01.052-.02.083-.031h.01c.01 0 .021-.01.031-.01.01 0 .01 0 .021-.01.01 0 .02-.011.031-.011h.01l.125-.031h.02c.01 0 .021-.01.031-.01 0 0 .01 0 .021-.01.01 0 .02 0 .031-.011h.01c.021 0 .052-.01.073-.01h.01c.01 0 .02 0 .031-.01H7.507c.021 0 .052 0 .083-.011-.072-.01-.155-.01-.227-.01C4.912.231 1.52 4.791 0 10.685h.29c.486-.869.93-1.696 1.323-2.461C2.69 4.037 4.86 1.183 6.793.428Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D82CA",
    d: "M8.18 2.113c.268-.259.548-.497.837-.714a4.432 4.432 0 0 0-.196-.382c-.228.258-.435.62-.641 1.096ZM8.376.469c.166.134.3.32.434.538.042-.052.083-.093.125-.145a2.769 2.769 0 0 0-.59-.414c.01.01.02.01.031.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M1.624 8.214C3.868 3.902 4.922 1.172 6.794.428c-1.934.755-4.105 3.609-5.17 7.786Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#127BCA",
    d: "M8.945.861a1.8 1.8 0 0 0-.124.145c.072.124.145.248.196.383l.248-.186c-.103-.114-.206-.228-.32-.342Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M2.637 10.665h-.093c-.031 0-.052 0-.083.01h-.01c2.264-.062 3.299-1.2 3.816-2.844.393-1.25.713-2.295.992-3.185-.951 1.334-1.902 2.927-2.864 4.716-.455.858-1.158 1.22-1.758 1.303Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M2.637 10.665c.6-.072 1.303-.434 1.768-1.292.962-1.79 1.913-3.382 2.865-4.716.34-1.086.63-1.913.91-2.544-1.893 1.8-3.795 4.788-5.543 8.552Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#05A1E6",
    d: "M1.623 8.214A90.407 90.407 0 0 1 .3 10.675h.858c.093-.827.259-1.644.466-2.461Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M7.518.241H7.446c-.01 0-.021 0-.032.01h-.01c-.02 0-.052.01-.072.01h-.01c-.011 0-.021.011-.032.011h-.02c-.01 0-.021 0-.031.01h-.021l-.124.032h-.01c-.01 0-.021.01-.042.01h-.02c-.01 0-.021.01-.032.01h-.01c-.031.01-.052.021-.083.031-.01 0-.02.01-.041.01 0 0-.01 0-.02.011-.011 0-.021.01-.032.01 0 0-.01 0-.01.01-1.872.735-2.937 3.475-5.17 7.787a21.993 21.993 0 0 0-.476 2.462H2.46c.031 0 .052 0 .083-.01h.093C4.385 6.88 6.287 3.891 8.18 2.091c.206-.475.413-.827.64-1.106a2.433 2.433 0 0 0-.444-.517c-.01 0-.02-.01-.03-.01-.011 0-.022-.011-.032-.011-.01 0-.02-.01-.02-.01-.011 0-.021-.01-.032-.01-.01 0-.01-.011-.02-.011-.021-.01-.031-.01-.052-.02-.01 0-.01-.011-.02-.011-.011 0-.021-.01-.042-.01-.01 0-.01 0-.02-.01-.021-.011-.032-.011-.052-.021-.021-.01-.042-.01-.063-.021h-.01c-.02 0-.03-.01-.052-.01h-.01L7.797.283h-.01c-.021 0-.031-.01-.052-.01h-.01c-.021 0-.042-.011-.062-.011h-.01c-.021 0-.032 0-.052-.01-.032-.01-.052 0-.083-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M20.258 2.806c-.435 1.375-.776 2.523-1.086 3.454 1.179-1.624 2.347-3.671 3.454-6.04-1.283.414-1.975 1.345-2.368 2.586Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M19.213 10.076c-.062.03-.124.062-.175.083 2.295-1.024 5.046-5.098 6.36-10.155h-.27C22.108 5.392 21.137 9 19.213 10.076Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#079AE1",
    d: "M17.714 9.62c.496-.61.91-1.644 1.468-3.36-.64.879-1.292 1.644-1.933 2.254v.01c.134.424.29.797.465 1.097Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1969BC",
    d: "M17.714 9.62a2.181 2.181 0 0 1-.548.486c-.041.02-.093.052-.135.072.218.114.455.197.704.218.041 0 .072.01.113.01h.383c.02 0 .031 0 .052-.01h.01c.02 0 .031-.01.052-.01h.01c.031-.011.072-.011.104-.021-.28-.114-.528-.373-.745-.745Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E5CB3",
    d: "M13.474 10.406c.217 0 .434-.02.652-.062.206-.041.403-.093.61-.165.165.082.351.144.537.186.145.03.3.041.455.041h-2.254Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E5CB3",
    d: "M15.718 10.407c.527 0 .951-.062 1.313-.238.218.114.455.196.704.217.041 0 .072.01.113.01h.124l-2.254.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D60B5",
    d: "M17.972 10.407h.259c.02 0 .031 0 .052-.01h.01c.02 0 .031 0 .052-.011h.01c.041-.01.072-.01.103-.02a.895.895 0 0 0 .331.061l-.817-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#175FAB",
    d: "M17.238 8.524c-.227.218-.465.424-.713.62l-.373.28c.104.124.207.238.321.352.165.165.352.3.548.403.041-.02.093-.041.134-.072.197-.114.383-.28.548-.486-.165-.3-.32-.673-.465-1.097Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M24.28.004h-1.344c-.072 0-.145.01-.217.01-.031.072-.062.145-.104.207-1.106 2.357-2.274 4.405-3.453 6.039-.559 1.706-.962 2.75-1.469 3.36.217.362.466.621.755.735.01 0 .02 0 .02-.01h.021c.01 0 .021-.011.042-.011.01 0 .01 0 .02-.01.01 0 .021-.01.032-.01.01 0 .01 0 .02-.011.02-.01.031-.01.052-.01.01 0 .02-.01.02-.01.011 0 .021-.011.032-.011.01 0 .02-.01.03-.01.011 0 .021-.01.021-.01.021-.011.042-.011.062-.021.01 0 .01 0 .021-.01.01 0 .02-.011.031-.011 0 0 .01 0 .01-.01.042-.021.083-.031.124-.052.063-.031.125-.052.176-.083 1.924-1.075 2.896-4.684 5.915-10.072l-.817.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7DCBEC",
    d: "M7.6.241H7.653c.02 0 .042.01.062.01h.01c.021 0 .032.011.052.011h.01l.125.031h.01c.02 0 .031.01.052.01h.01c.02 0 .042.01.062.021.02 0 .031.01.052.02.01 0 .01 0 .02.011.01.01.021.01.042.01.01 0 .01 0 .02.01.021.011.032.011.052.021.01 0 .021.01.021.01.01 0 .02.011.031.011.01 0 .02.01.031.01.01 0 .02.01.031.01.217.104.414.249.59.414.062-.072.134-.134.206-.186A2.348 2.348 0 0 0 7.766.221a.905.905 0 0 1-.165.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5EC5ED",
    d: "M8.945.862c.114.103.217.227.32.34.093-.072.197-.134.29-.196a3.197 3.197 0 0 0-.403-.341c-.073.062-.145.134-.207.197Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M7.6.242c.063 0 .125-.01.187-.01.517 0 .972.165 1.375.444.424-.33.93-.445 1.634-.445H7.363c.082 0 .155 0 .238.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M10.786.22c-.704 0-1.22.114-1.634.445.144.104.279.218.403.342.59-.373 1.168-.62 1.737-.724.217-.042.434-.062.652-.062h-1.159Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M19.182 6.26c.3-.941.652-2.079 1.086-3.454.393-1.24 1.075-2.171 2.368-2.575a1.29 1.29 0 0 1 .104-.207c-2.11.125-3.092 1.2-3.589 2.792-.868 2.772-1.396 4.571-1.902 5.719a18.477 18.477 0 0 0 1.933-2.275Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22.274 9.672h-.238v.745h-.093v-.745h-.238V9.58h.58l-.01.093Zm.972.745h-.093v-.559c0-.041 0-.093.01-.165-.01.041-.02.062-.03.083l-.28.64h-.051l-.28-.63a.16.16 0 0 1-.02-.083V10.427h-.093V9.6h.124l.258.579c.02.041.031.072.042.103.02-.041.03-.082.041-.103l.259-.58h.124l-.01.818Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.681 16.683h-1.81l-.289.859H.352l1.747-4.84h1.365l1.748 4.84H3.97l-.29-.859Zm-.3-.91-.6-1.768-.589 1.768h1.19ZM6.38 17.407a1.592 1.592 0 0 1-.672-.506 1.43 1.43 0 0 1-.269-.817h1.252c.02.175.082.32.186.413a.61.61 0 0 0 .413.145c.176 0 .31-.041.414-.124a.407.407 0 0 0 .155-.33.398.398 0 0 0-.124-.3.888.888 0 0 0-.3-.197c-.114-.052-.28-.104-.496-.176a5.497 5.497 0 0 1-.766-.29 1.329 1.329 0 0 1-.506-.423c-.145-.187-.217-.435-.217-.735 0-.455.165-.806.486-1.055.33-.258.755-.382 1.272-.382.537 0 .961.124 1.292.382.331.259.497.61.528 1.066H7.766a.493.493 0 0 0-.176-.373.577.577 0 0 0-.403-.134.502.502 0 0 0-.341.114.426.426 0 0 0-.135.33c0 .156.073.28.217.362.145.083.373.187.693.28.31.103.569.207.765.3.197.093.362.237.507.424.145.186.217.424.217.713 0 .28-.072.527-.207.755a1.48 1.48 0 0 1-.61.538c-.269.134-.579.196-.94.196-.373 0-.694-.051-.973-.176ZM13.153 15.02c-.124.227-.33.423-.589.558-.269.144-.6.217-.993.217h-.734v1.737H9.658v-4.84h1.913c.383 0 .714.062.983.197.269.134.465.32.6.548.134.238.196.507.196.806-.01.29-.072.549-.197.776Zm-1.178-.322c.113-.103.165-.258.165-.444s-.052-.341-.165-.445c-.114-.103-.28-.155-.507-.155h-.641v1.21h.641c.238 0 .403-.052.507-.166ZM19.172 17.428h-.62l-2.493-3.785v3.785h-.62V12.67h.62l2.492 3.774v-3.774h.621v4.757ZM20.847 13.188v1.592h1.727v.507h-1.727v1.634h1.934v.507h-2.554V12.67h2.554v.507h-1.934v.01ZM26.648 12.682v.506h-1.292v4.25h-.62v-4.25h-1.304v-.506h3.216ZM14.002 17.552a.393.393 0 1 0 0-.785.393.393 0 0 0 0 .785Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 4.862,
    x2: 4.862,
    y1: 554.133,
    y2: -457.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A1E6",
    stopOpacity: 0.549
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 11.72,
    x2: 11.72,
    y1: -165.576,
    y2: 1113.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0994DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#66CEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#127BCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#127BCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 14.844,
    x2: 14.844,
    y1: 988.748,
    y2: -55.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C63B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#33BDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33BDF2",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 14.158,
    x2: 14.158,
    y1: -177.945,
    y2: 1184.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#166AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#36AEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#0798DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0798DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 13.085,
    x2: 13.085,
    y1: -189.105,
    y2: 1259.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1487CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#165197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165197"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 7.267,
    x2: 9.315,
    y1: 3.022,
    y2: 3.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33BDF2",
    stopOpacity: 0.698
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DACD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 22.646,
    x2: 22.646,
    y1: 985.419,
    y2: -31.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#136AB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#59CAF5",
    stopOpacity: 0.549
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CAF5",
    stopOpacity: 0.235
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -0.008,
    x2: 759.575,
    y1: 5.453,
    y2: 5.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05A1E6",
    stopOpacity: 0.247
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A1E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 4.207,
    x2: 4.207,
    y1: 968.311,
    y2: -72.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#318ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38A7E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 12.208,
    x2: 12.208,
    y1: -170.122,
    y2: 1141.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E76BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#36AEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#00ADEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ADEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 5.406,
    x2: 5.406,
    y1: 857.456,
    y2: 2.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1959A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#05A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#7EC5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EC5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 339.146,
    x2: 49.236,
    y1: 1027.08,
    y2: 141.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#165096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D82CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 20.906,
    x2: 20.906,
    y1: 464.935,
    y2: -19.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#0495D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0495D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 109.526,
    x2: -342.132,
    y1: -188.349,
    y2: 814.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A7E4",
    stopOpacity: 0.329
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#0E88D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E88D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 21.419,
    x2: 21.419,
    y1: -3.062,
    y2: 1054.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168CD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1C87CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#154B8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 5.387,
    x2: 9.97,
    y1: -89.025,
    y2: 21.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97D6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#55C1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 11.838,
    x2: 32.546,
    y1: -6.875,
    y2: -124.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ACCEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB7ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 19.989,
    x2: 19.989,
    y1: 54.126,
    y2: 1088.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DA7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ABE7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h27v18H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAspnet);
export default __webpack_public_path__ + "static/media/ASP.NET.aab2bbde6f47b829f95a78b3c9335a02.svg";
export { ForwardRef as ReactComponent };